// src/components/ProductCard.js
import React, { useState } from 'react';
import { useCart } from '../context/CartContext'; // <-- 1. Importamos el hook del carrito
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, Eye } from 'lucide-react';
import './ProductCard.css';
import toast from 'react-hot-toast';

const ProductCard = ({ product }) => {
  // 2. Creamos estados para manejar la opción de precio y la cantidad
  const [selectedPrice, setSelectedPrice] = useState(product.precios[0]);
  const [quantity, setQuantity] = useState(1);
  const { addProduct } = useCart(); // 3. Obtenemos la función para añadir productos
  const navigate = useNavigate();

  // Formateador para moneda colombiana
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
    }).format(value);
  };

  // 4. Función que se ejecuta al hacer clic en "Añadir al Carrito"
  const handleAddToCart = () => {
    addProduct(product, quantity, selectedPrice);
    toast.success(
      `${quantity} x ${product.nombre} añadido!`,
      { icon: '🛒' } // ¡Podemos hasta añadir iconos!
    );
    // Podríamos mostrar una notificación más elegante en el futuro
  };

  return (
    <div className="product-card">
      <div
        className="product-card-image-wrapper"
        onClick={() => navigate(`/producto/${product.id}`)}
        style={{ cursor: 'pointer' }}
      >
        <img src={product.imagen} alt={product.nombre} className="product-card-image" />
        <button
          className="btn-view-details"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/producto/${product.id}`);
          }}
          title="Ver detalles"
        >
          <Eye size={20} />
        </button>
      </div>
      <div className="product-card-body">
        <h3
          className="product-card-title"
          onClick={() => navigate(`/producto/${product.id}`)}
          style={{ cursor: 'pointer' }}
        >
          {product.nombre}
        </h3>
        {product.peso && (
          <p className="product-card-weight">{product.peso}</p>
        )}
        <p className="product-card-description">{product.descripcion}</p>

        {/* 5. Selector de presentación (siempre se muestra) */}
        <div className="product-options">
          <label htmlFor={`price-select-${product.id}`}>Presentación:</label>
          <div className="custom-select-wrapper">
            <div className="custom-select-display">
              <span className="select-label">
                {selectedPrice.presentacion || `${selectedPrice.unidades} unidades`}
              </span>
              <span className="select-price">
                {formatCurrency(selectedPrice.valor)}
              </span>
              <div className="select-arrow">▼</div>
            </div>
            <select
              id={`price-select-${product.id}`}
              value={JSON.stringify(selectedPrice)}
              onChange={(e) => {
                const newPriceOption = JSON.parse(e.target.value);
                setSelectedPrice(newPriceOption);
              }}
              className="hidden-native-select"
            >
              {product.precios.map((p, idx) => {
                const label = p.presentacion || `${p.unidades} un.`;
                const shortPrice = formatCurrency(p.valor).replace(/\s/g, '');
                return (
                  <option key={idx} value={JSON.stringify(p)}>
                    {`${label} - ${shortPrice}`}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        {/* 6. Controles para añadir al carrito */}
        <div className="add-to-cart-controls">
          <div className="quantity-selector">
            <button onClick={() => setQuantity(q => Math.max(1, q - 1))}>-</button>
            <input type="number" value={quantity} readOnly />
            <button onClick={() => setQuantity(q => q + 1)}>+</button>
          </div>
          <button className="add-to-cart-button" onClick={handleAddToCart}>
            <ShoppingCart size={18} />
            Añadir
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;